// 🤖 今日のおすすめ — Mobile 専用 単条 CTA Card
//
// 設計判断(2026-09-16):
// - PC の AiRecommendedActions から派生。summary(長文)・priority badge・複数条を削除
// - 永远 1 条(actions[0])。AI 已经排序,二次决策は user 経験を下げる
// - 语气:Apple Watch / Google Photos 風「温和な提案」、警告型は避ける
// - timestamp:「AI分析 HH:MM」(date は cross-day refresh で常に今日なので省略)
// - 4 状態:
//   - loading  (初期:cache なし、no previous data → skeleton body)
//   - refreshing(再 fetch 中、previous あり → skeleton body + 旧 timestamp)
//   - ready    (recommendation あり)
//   - empty    (actions=[]、今日は特にありません)
//
// PC DashboardPage の AiRecommendedActions は触らない(mobile-companion 铁律)。

import { Link } from "react-router-dom";
import { MobileCard } from "./MobileCard";
import { resolveMobileTargetRoute, hasMobileTargetRoute } from "../utils/targetRoute";
import type { DashboardAiInsight } from "../../api/dashboard";

type Props = {
  loading: boolean;
  refreshing: boolean;
  insight: DashboardAiInsight | null;
  fetchedAt: Date | null;
};

function formatTimeOnly(date: Date): string {
  const hh = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  return `${hh}:${min}`;
}

function AiSkeletonBody() {
  return (
    <div className="mobile-ai-skeleton">
      <div className="mobile-ai-skeleton-label">
        <span className="mobile-ai-skeleton-dot" />
        生成中…
      </div>
      <div className="mobile-ai-skeleton-bars">
        <span className="mobile-ai-skeleton-bar" style={{ width: "82%" }} />
        <span className="mobile-ai-skeleton-bar" style={{ width: "60%" }} />
        <span className="mobile-ai-skeleton-bar" style={{ width: "44%" }} />
      </div>
    </div>
  );
}

export const MobileAiRecommendationCard = ({
  loading,
  refreshing,
  insight,
  fetchedAt,
}: Props) => {
  const action = insight && insight.actions.length > 0 ? insight.actions[0] : null;
  const hasTarget = action ? hasMobileTargetRoute(action.targetModule) : false;
  const targetRoute = action ? resolveMobileTargetRoute(action.targetModule) : "/mobile/dashboard";

  // loading = initial load (no previous data)
  // refreshing = re-fetch (have previous insight, show timestamp)
  const showSkeleton = (loading && !action) || (refreshing && !action);
  const showSkeletonWithOldTimestamp = refreshing && action;

  return (
    <MobileCard title="🤖 今日のおすすめ">
      {showSkeleton ? (
        <>
          <AiSkeletonBody />
          {fetchedAt && (
            <div className="mobile-ai-timestamp">
              AI分析 {formatTimeOnly(fetchedAt)}
            </div>
          )}
        </>
      ) : showSkeletonWithOldTimestamp ? (
        <>
          <AiSkeletonBody />
          {fetchedAt && (
            <div className="mobile-ai-timestamp">
              AI分析 {formatTimeOnly(fetchedAt)}
            </div>
          )}
        </>
      ) : action ? (
        <>
          <p className="mobile-ai-reason">{action.reason}</p>
          {hasTarget && (
            <Link to={targetRoute} className="mobile-ai-cta">
              {action.buttonLabel} →
            </Link>
          )}
          <div className="mobile-ai-divider" />
          <div className="mobile-ai-timestamp">
            AI分析 {fetchedAt ? formatTimeOnly(fetchedAt) : "—"}
          </div>
        </>
      ) : (
        <>
          <p className="mobile-ai-empty">今日は特にありません。良い一日を。</p>
          {fetchedAt && (
            <div className="mobile-ai-timestamp">
              AI分析 {formatTimeOnly(fetchedAt)}
            </div>
          )}
        </>
      )}
    </MobileCard>
  );
};
